import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import PVForms from "../../Custom/PVForms";
import { useDispatch, useSelector } from "react-redux";
import { createGame, gameSelector, getGame, joinGame, makeMove, setPlayers, startGame } from "../../services/GameSlice";
import { nanoid } from "@reduxjs/toolkit";
import PVTable from "../../Custom/PVTable";

const Board = () => {

    const params = useParams();

    const [record, setRecord] = useState({});
    const [nameRecord, setNameRecord] = useState({});
    const [userId, setUserId] = useState('');
    const [selectedCard, setSelectedCard] = useState(null);

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const game = useSelector(gameSelector);

    const data = {
        '0,0': 'blank_card',
        '0,1': 'spades_10',
        '0,2': 'spades_queen',
        '0,3': 'spades_king',
        '0,4': 'spades_ace_simple',
        '0,5': 'diamonds_2',
        '0,6': 'diamonds_3',
        '0,7': 'diamonds_4',
        '0,8': 'diamonds_5',
        '0,9': 'blank_card',

        '1,0': 'spades_9',
        '1,1': 'hearts_10',
        '1,2': 'hearts_9',
        '1,3': 'hearts_8',
        '1,4': 'hearts_7',
        '1,5': 'hearts_6',
        '1,6': 'hearts_5',
        '1,7': 'hearts_4',
        '1,8': 'hearts_3',
        '1,9': 'diamonds_6',

        '2,0': 'spades_8',
        '2,1': 'hearts_queen',
        '2,2': 'diamonds_7',
        '2,3': 'diamonds_8',
        '2,4': 'diamonds_9',
        '2,5': 'diamonds_10',
        '2,6': 'diamonds_queen',
        '2,7': 'diamonds_king',
        '2,8': 'hearts_2',
        '2,9': 'diamonds_7',

        '3,0': 'spades_7',
        '3,1': 'hearts_king',
        '3,2': 'diamonds_6',
        '3,3': 'clubs_2',
        '3,4': 'hearts_ace',
        '3,5': 'hearts_king',
        '3,6': 'hearts_queen',
        '3,7': 'diamonds_ace',
        '3,8': 'spades_2',
        '3,9': 'diamonds_8',

        '4,0': 'spades_6',
        '4,1': 'hearts_ace',
        '4,2': 'diamonds_5',
        '4,3': 'clubs_3',
        '4,4': 'hearts_4',
        '4,5': 'hearts_3',
        '4,6': 'hearts_10',
        '4,7': 'clubs_ace',
        '4,8': 'spades_3',
        '4,9': 'diamonds_9',

        '5,0': 'spades_5', 
        '5,1': 'clubs_2',
        '5,2': 'diamonds_4',
        '5,3': 'clubs_4',
        '5,4': 'hearts_5',
        '5,5': 'hearts_2',
        '5,6': 'hearts_9',
        '5,7': 'clubs_king',
        '5,8': 'spades_4',
        '5,9': 'diamonds_10',

        '6,0': 'spades_4',
        '6,1': 'clubs_3',
        '6,2': 'diamonds_3',
        '6,3': 'clubs_5',
        '6,4': 'hearts_6',
        '6,5': 'hearts_7',
        '6,6': 'hearts_8',
        '6,7': 'clubs_queen',
        '6,8': 'spades_5',
        '6,9': 'diamonds_queen',

        '7,0': 'spades_3',
        '7,1': 'clubs_4',
        '7,2': 'diamonds_2',
        '7,3': 'clubs_6',
        '7,4': 'clubs_7',
        '7,5': 'clubs_8',
        '7,6': 'clubs_9',
        '7,7': 'clubs_10',
        '7,8': 'spades_6',
        '7,9': 'diamonds_king',

        '8,0': 'spades_2',
        '8,1': 'clubs_5',
        '8,2': 'spades_ace_simple',
        '8,3': 'spades_king',
        '8,4': 'spades_queen',
        '8,5': 'spades_10',
        '8,6': 'spades_9',
        '8,7': 'spades_8',
        '8,8': 'spades_7',
        '8,9': 'diamonds_ace',

        '9,0': 'blank_card',
        '9,1': 'clubs_6',
        '9,2': 'clubs_7',
        '9,3': 'clubs_8',
        '9,4': 'clubs_9',
        '9,5': 'clubs_10',
        '9,6': 'clubs_queen',
        '9,7': 'clubs_king',
        '9,8': 'clubs_ace',
        '9,9': 'blank_card'
    }

    useEffect(() => {
        let userId = localStorage.getItem("userId");
        setUserId(userId);
        if(!Boolean(userId)){
            userId = nanoid();
            localStorage.setItem("userId", userId);
            setUserId(userId);
        }
        if(!Boolean(params.gameId)){
            setRecord({open: true})
        } else if(nameRecord?.open !== true){
            dispatch(getGame(params.gameId, userId, (game) => {
                if(game?.players){
                    if(game.players.filter(item => item.userId === userId).length === 0 && nameRecord?.open !== true){
                        setNameRecord({open: true, editRecord: {userId: userId}});
                    } else if(game.players.filter(item => item.userId === userId).length === 1 && game.status === 'INIT'){
                        setInterval(() => {
                            dispatch(getGame(params.gameId, userId));
                        }, 1000);
                    } else if(game.status === 'START'){
                        setInterval(() => {
                            dispatch(getGame(params.gameId, userId));
                        }, 1000);
                    }
                        
                }
            }));
        }
    }, [params, dispatch, nameRecord])

    const create = () => {
        dispatch(createGame(record.editRecord, (game) => {
            setRecord({});
            navigate(`/${game._id}`)
        }));
    }

    const join = () => {
        dispatch(joinGame(params.gameId, nameRecord.editRecord, () => setNameRecord({})));
    }

    const start = () => {
        dispatch(startGame(params.gameId));
    }

    const canStartGame = () => {
        if(game?.players?.length === game?.noOfPlayers
            && game?.players?.filter(item => item.team === undefined).length === 0){
            let count = {};
            game.players.forEach(item => {
                if(count[item.team]){
                    count[item.team] += 1;
                } else {
                    count[item.team] = 1;
                }
            })
            let values = Object.values(count);
            if(values.every(val => val === values[0])){
                return true;
            }     
        }
        return false;
    }

    const move = (pos) => {
        if(((!Boolean(game?.moves?.find(m => m.pos === pos)) && selectedCard === data[pos]) ||
            (['spades_jack', 'hearts_jack'].includes(selectedCard) && game?.moves?.find(m => m.pos === pos && m.team !== game?.players?.find(p => p.userId === userId)?.team?.toLowerCase())) ||
            (['clubs_jack', 'diamonds_jack'].includes(selectedCard) && !Boolean(game?.moves?.find(m => m.pos === pos)))) && game.currentPlayer === userId &&
            ![`0,0`, `0,9`, `9,0`, `9,9`].includes(pos)){
                dispatch(makeMove(params.gameId, pos, userId, selectedCard, game));
        }
    }

    const onRowClick = (data, key) => {
        let players;
        switch (key){
            case 'assignGreen':
                players = game.players.map(item => {
                    if(item.userId === data.userId){
                        return {...item, team: 'Green'}
                    }
                    return item;
                })
                dispatch(setPlayers(game._id, players));
                break;
            case 'assignBlue': 
                players = game.players.map(item => {
                    if(item.userId === data.userId){
                        return {...item, team: 'Blue'}
                    }
                    return item;
                })
                dispatch(setPlayers(game._id, players));
                break;
            case 'assignRed':
                players = game.players.map(item => {
                    if(item.userId === data.userId){
                        return {...item, team: 'Red'}
                    }
                    return item;
                })
                dispatch(setPlayers(game._id, players));
                break;
            default:
                console.log("Nothing to execute");
        }
    }

    const cursor = (pos) => {
        if(((!Boolean(game?.moves?.find(m => m.pos === pos)) && selectedCard === data[pos]) ||
            (['spades_jack', 'hearts_jack'].includes(selectedCard) && game?.moves?.find(m => m.pos === pos && m.team !== game?.players?.find(p => p.userId === userId)?.team?.toLowerCase())) ||
            (['clubs_jack', 'diamonds_jack'].includes(selectedCard) && !Boolean(game?.moves?.find(m => m.pos === pos)))) && game.currentPlayer === userId &&
            ![`0,0`, `0,9`, `9,0`, `9,9`].includes(pos)){
            return 'pointer';
        }
        return 'not-allowed';
    }

    return (
        <Grid style={{backgroundColor: '#03b1fc', width: '100vw', minHeight: '100vh'}}>
            <Grid container style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
                <Grid item>
                </Grid>
                <Grid item style={{display: 'flex', justifyContent: 'center'}}>
                    <Typography variant="h4">{game.status === 'COMPLETED'? 'Somebody won' : game.currentPlayer === userId ? 'Your Turn' : 'Not your turn'}</Typography>
                </Grid>
                <Grid item>
                    <Button variant="contained" style={{marginRight: 20, marginTop: 10}} onClick={() => {
                        navigate('/');
                        window.location.reload();
                    }}>New Game</Button>
                </Grid>
            </Grid>
            
            <Dialog open={game?.status === 'INIT' && game?.players?.length > 0}>
                <DialogTitle>Team</DialogTitle>
                <DialogContent>
                    <PVTable 
                        columns={[
                            {
                                label: 'Name',
                                property: 'name'
                            },
                            {
                                label: 'Team',
                                property: 'team'
                            }
                        ]}
                        data={game.players}
                        clickMenu={[
                            {
                                key: 'assignGreen',
                                label: 'Assign Green',
                                enabled: (game?.noOfPlayers % 2 === 0 || game?.noOfPlayers % 3 === 0) && game?.players?.filter(item => item.team === 'Green').length < Math.floor(game?.noOfPlayers / 2)
                            },
                            {
                                key: 'assignBlue',
                                label: 'Assign Blue',
                                enabled: (game?.noOfPlayers % 2 === 0 || game?.noOfPlayers % 3 === 0) && game?.players?.filter(item => item.team === 'Blue').length < Math.floor(game?.noOfPlayers / 2)
                            },
                            {
                                key: 'assignRed',
                                label: 'AssignRed',
                                enabled: game?.noOfPlayers % 3 === 0
                            }
                        ]}
                        onRowClick={onRowClick}
                    />
                </DialogContent>
                <DialogActions style={{textAlign: 'center'}}>
                    <Button onClick={start} disabled={!canStartGame()}>Start Game</Button>
                </DialogActions>
            </Dialog>
            {console.log(window.location.href)}
            <PVForms 
                fields={[
                    {
                        label: 'Room Name',
                        property: 'roomName',
                        required: true
                    },
                    {
                        label: 'Number of Players',
                        property: 'noOfPlayers',
                        required: true,
                        dataType: 'number',
                        error: Boolean(record?.editRecord?.noOfPlayers) && !(record?.editRecord?.noOfPlayers > 1 
                            && record?.editRecord?.noOfPlayers <= 12 
                            && (record?.editRecord?.noOfPlayers % 2 === 0 || record?.editRecord?.noOfPlayers % 3 === 0))
                    }
                ]}
                record={record}
                onChangeRecord={setRecord}
                title="Create a Game"
                onSaveClicked={create}
            />
            <PVForms 
                fields={[
                    {
                        label: 'Name',
                        property: 'name',
                        required: true
                    }
                ]}
                record={nameRecord}
                onChangeRecord={setNameRecord}
                title="User Name"
                saveLabel={'Join Game'}
                onSaveClicked={join}
            />
            <Grid container>
                <Grid item xs={12} md={8} lg={8} style={{marginTop: '10vh', textAlign: 'center'}}>
                    <Typography variant="h3">Board</Typography>
                    {Array.from({ length: 10 }).map((lol, i) => (
                        <Grid container key={i}>
                            <Grid item xs={1} md={1} lg={1}/>
                            {Array.from({ length: 10 }).map((lol1, j) => (
                                <Grid item xs={1} md={1} lg={1} key={j} style={{ paddingLeft: 5, paddingRight: 5, textAlign: 'center', position: 'relative' }}>
                                <img
                                    src={`https://skilledin-resources.s3.us-east-2.amazonaws.com/65777e4bf3e55914957c7b26/65777e4cf3e55914957c7b29/cardfronts/${Object.keys(data).includes(`${i},${j}`) ? data[`${i},${j}`] : 'spades_ace_simple'}.png`}
                                    alt={`At ${i} ${j}`}
                                    width={'100%'}
                                    onClick={() => move(`${i},${j}`)}
                                    style={{cursor: cursor(`${i},${j}`),
                                            border: Boolean(game?.moves?.find(m => m.pos === `${i},${j}`)?.completedSequence) ? '2px solid black' : 'none',}}
                                />
                                {game?.moves && Boolean(game.moves.find(m => m.pos === `${i},${j}`)) && <div style={{
                                    position: 'absolute',
                                    top: '50%',
                                    left: '50%',
                                    transform: 'translate(-50%, -50%)',
                                    width: 25,
                                    height: 25,
                                    backgroundColor: game.moves.find(m => m.pos === `${i},${j}`).team,
                                    borderRadius: '50%',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    cursor: cursor(`${i},${j}`)
                                }} />}
                                </Grid>
                            ))}
                            <Grid item xs={1} md={1} lg={1}/>
                        </Grid>
                    ))}
                </Grid>
                <Grid item xs={12} md={4} lg={4} style={{marginTop: '10vh'}}>
                    <Typography variant="h3">{`Your Cards (${Boolean(game?.players?.find(p => p.userId === userId)?.team) ? game?.players?.find(p => p.userId === userId)?.team: ''})`}</Typography>
                    <Typography variant="body1">{`Current Player - ${Boolean(game?.players?.find(p => p.userId === game?.currentPlayer)?.name) ? game?.players?.find(p => p.userId === game?.currentPlayer)?.name : ''}`}</Typography>
                    <Grid container style={{justifyContent: 'center', marginTop: '5vh'}}>
                        {game?.players?.filter(user => user.userId === userId)?.[0]?.inHandCards && game?.players?.filter(user => user.userId === userId)[0]?.inHandCards.map((_, i) => (
                            <Grid item xs={3} md={3} lg={3}>
                                <img
                                    src={`https://skilledin-resources.s3.us-east-2.amazonaws.com/65777e4bf3e55914957c7b26/65777e4cf3e55914957c7b29/cardfronts/${game?.players?.filter(user => user.userId === userId)[0]?.inHandCards[i]}.png`}
                                    alt={`At ${i} ${i}`}
                                    width={'100%'}
                                    onClick={() => {
                                        if(game.currentPlayer === userId){
                                            setSelectedCard(game?.players?.filter(user => user.userId === userId)[0]?.inHandCards[i])
                                        }
                                    }}
                                    style={{cursor: game.currentPlayer === userId ? 'pointer' : 'not-allowed',
                                            transform: 'rotate(-90deg)'}}
                                />
                            </Grid>
                        ))}
                    </Grid>
                    {/* <Grid container style={{justifyContent: 'center', marginTop: '6vh', padding: 20}}>
                        <Grid xs={12} md={12} lg={12}>
                        <Typography variant="h5">{`Players`}</Typography>
                            <PVTable 
                                columns={[
                                    {
                                        label: 'Name',
                                        property: 'name'
                                    },
                                    {
                                        label: 'Team',
                                        property: 'team'
                                    }
                                ]}
                                data={game.players}
                                active={(item) => item.userId === game.currentPlayer}
                            />
                        </Grid>
                    </Grid> */}
                </Grid>
            </Grid>
        </Grid>
    )
}

export default Board;